export type SnackbarType = 'success' | 'error' | 'warning' | 'info';
export type SnackbarPosition = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';

let activeSnackbar: HTMLTambrSnackbarElement;

export function openSnackbar(
  message: string,
  type: SnackbarType,
  duration = 0,
  position: SnackbarPosition,
  buttonLabel?: string,
  buttonAction?: () => void
) {
  activeSnackbar = document.createElement('tambr-snackbar') as HTMLTambrSnackbarElement;
  activeSnackbar.message = message;
  activeSnackbar.type = type;
  activeSnackbar.duration = duration;
  activeSnackbar.position = position;
  if ( buttonLabel && buttonAction ) {
    activeSnackbar.buttonLabel = buttonLabel;
    activeSnackbar.buttonAction = buttonAction;
  }
  document.body.appendChild( activeSnackbar );
}

export function closeSnackbar() {
  if ( activeSnackbar ) {
    activeSnackbar.remove();
  }
}